import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

const ReCaptchaContainer = styled.div`
  margin-top: ${gridSize()}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export default ReCaptchaContainer;
